var _defs, _ellipse, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSantizer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 63.05,
    viewBox: "0 0 55 63.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.124,
    x2: 0.5,
    y2: 0.897,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0dff5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.03,
    y1: 0.567,
    x2: 0.796,
    y2: -0.316,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4b3c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 0.182,
    x2: 0.5,
    y2: 0.859,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: -0.128,
    x2: 0.5,
    y2: 0.937,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74c1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43a7b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 0.182,
    x2: 0.5,
    y2: 0.859,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.495,
    y1: 0.546,
    x2: 0.368,
    y2: 1.636,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e3192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10147a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.19,
    y1: 1.516,
    x2: 0.853,
    y2: -0.655,
    xlinkHref: "#linear-gradient-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2161",
    "data-name": "Group 2161",
    transform: "translate(0 0.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(0 0)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 27.5,
    cy: 27.464,
    rx: 27.5,
    ry: 27.464,
    transform: "translate(0 7.502)",
    fill: "#d2d5ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(9.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M463.563,355.882c0,1.573-7.956,2.849-17.77,2.849s-17.771-1.275-17.771-2.849,7.956-2.849,17.771-2.849S463.563,354.308,463.563,355.882Z",
    transform: "translate(-428.022 -303.67)",
    fill: "#d6cfe6",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(5.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(9.314 6.291)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 5.23,
    height: 12.431,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M454.177,281.569l5.23-3.259h-5.23Z",
    transform: "translate(-454.177 -277.93)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M454.177,294.65l5.23-3.259h-5.23Z",
    transform: "translate(-454.177 -283.432)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 5.23,
    height: 12.431,
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M450.032,295.1c-14.453,0-11.723,34.107-11.723,34.107,4.649,3.779,18.8,3.779,23.447,0C461.756,329.2,464.486,295.1,450.032,295.1Z",
    transform: "translate(-438.104 -278.699)",
    fill: "url(#linear-gradient-4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M439.67,316.494a67.012,67.012,0,0,0-1.442,12.048,85.738,85.738,0,0,0,23.716.069,67.343,67.343,0,0,0-1.427-12.044A73.6,73.6,0,0,1,439.67,316.494Z",
    transform: "translate(-438.156 -288.123)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M470.958,332.673c-2.2,1.813-6.525,2.777-10.97,2.868.564-.2,7.423-2.656,9.024-4.761,1.668-2.195-.431-23.577-2.717-28.768C472.656,311.133,470.958,332.673,470.958,332.673Z",
    transform: "translate(-447.307 -282.213)",
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M457.724,300.093c-4.057-4.961-7.689-3.881-7.689-3.881-10.158,1.231-11.722,33.553-11.722,33.553S435.584,295.1,450.034,295.1C453.491,295.1,455.965,297.079,457.724,300.093Z",
    transform: "translate(-438.105 -279.304)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M450.032,295.1c-14.453,0-11.723,34.107-11.723,34.107,4.649,3.779,18.8,3.779,23.447,0C461.756,329.2,464.486,295.1,450.032,295.1Z",
    transform: "translate(-438.104 -278.699)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(1.881)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M441.35,266.8v6.671h21.527v-2.577L444.761,266.8Z",
    transform: "translate(-441.35 -266.798)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M441.35,270.133l15.5,3.335h6.025v-2.577L444.761,266.8H441.35Z",
    transform: "translate(-441.35 -266.798)",
    fill: "#0071bc",
    opacity: 0.3,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M441.806,266.8l.379,5.778,20.692.893H441.35V266.8Z",
    transform: "translate(-441.35 -266.798)",
    fill: "#2974e2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M441.35,266.8v6.671h21.527v-2.577L444.761,266.8Z",
    transform: "translate(-441.35 -266.798)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(7.646 9.809)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 8.565,
    height: 4.321,
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 8.565,
    height: 1.743,
    transform: "translate(0 2.577)",
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 8.565,
    height: 4.321,
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantizer);
export default __webpack_public_path__ + "static/media/santizer.eb1f2400e40559bc0dfd51c140b2059c.svg";
export { ForwardRef as ReactComponent };